import { defineComponent as _defineComponent } from 'vue';
import { ref, computed } from 'vue';
import { ACTIONS_COL } from '@/types/interfaces';
import { DRAWER_CLOSED } from '@/constants/icons';
export default /*#__PURE__*/_defineComponent({
  __name: 'base',
  props: {
    isSelected: {
      type: Boolean
    },
    isExpanded: {
      type: Boolean
    },
    canSelect: {
      type: Boolean,
      default: true
    },
    canExpand: {
      type: Boolean,
      default: true
    },
    height: {
      default: '75px'
    },
    borderColor: {
      default: ''
    },
    tabText: {
      default: ''
    },
    tabIcon: {
      default: ''
    },
    createdAt: {
      default: ''
    },
    firstRow: {
      type: Boolean,
      default: true
    },
    lastRow: {
      type: Boolean,
      default: true
    },
    hasBorder: {
      type: Boolean
    },
    backgroundColor: {
      default: 'layer'
    },
    hasHover: {
      type: Boolean,
      default: true
    },
    columnDefs: null,
    size: {
      default: 'lg'
    },
    showActions: {
      type: Boolean,
      default: true
    },
    selectionDisabled: {
      type: Boolean
    },
    canRemove: {
      type: Boolean
    },
    isTile: {
      type: Boolean
    },
    showFooter: {
      type: Boolean
    },
    canAdd: {
      type: Boolean
    },
    additionalActionClass: {
      default: ''
    },
    isIndeterminate: {
      type: Boolean,
      default: false
    }
  },
  emits: ['row-click', 'toggle-select', 'row-dblclick', 'toggle-expand', 'remove', 'add'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const hovering = ref(false);
    const emitRowClick = () => {
      if (!props.selectionDisabled) emit('row-click');
    };
    const getHeaderClass = header => {
      return header.visibility;
    };
    const isLocalIndeterminate = computed(() => props.isIndeterminate);
    return {
      __sfc: true,
      props,
      emit,
      hovering,
      emitRowClick,
      getHeaderClass,
      isLocalIndeterminate,
      ACTIONS_COL,
      DRAWER_CLOSED
    };
  }
});